import React, { Component } from "react";
import { connect } from "react-redux";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import { getIPDetails, otherInfoSkip, otherInfoUpate, updateOtherInfo } from "../../actions/loginActions";
import {  isValidCharacter, TOAST_ERROR, TOAST_SUCCESS } from "../../utils";
import $ from "jquery";
import { Helmet } from "react-helmet";
import { LIVE_API } from "../../actions/api";
import { selectProduct } from "../../actions/initActions";
import { FontAwesomeIcon } from "../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";

const isValidNumber = (n) => {
  return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
};

class OtherInfo extends Component {
  constructor(props) {
    super(props);
  }

  onInTelLoad = () => {
    var errorMsg = document.querySelector("#error-msg"),
      validMsg = document.querySelector("#valid-msg");
    var submitBtn = document.getElementById("register-submit-btn");
    var contactError = document.getElementById("contact-error");

    var input = document.querySelector("#phone");

    if (input) {
      var reset = function () {
        input.classList.remove("error");
        errorMsg.innerHTML = "";
        errorMsg.classList.add("hide");
        submitBtn.disabled = false;
      };

      input.addEventListener("blur", function () {
        reset();
        var contactNo = input.value.trim();

        if (contactNo) {
          if (isNumber(contactNo)) {
            validMsg.classList.remove("hide");
            submitBtn.disabled = false;
            contactError.style.display = "none";
          } else {
            input.classList.add("error");
            errorMsg.classList.remove("hide");
            contactError.style.display = "none";
          }
        }
      });
      input.addEventListener("change", reset);
      input.addEventListener("keyup", reset);
      function isNumber(n) {
        return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
      }
    }
  };

  state = { organization: this.props?.userData?.organization || '', acnError: null, phoneError: null, phone: this.props?.userData?.contact_no || "", spinner: false, country_code: this.props?.userData?.country_code || null, telValue: null, phoneValid: null, countrySortname: null, skipRequest: false, orgErrorMsg: "", desErrorMsg: "", designation: this.props?.userData?.designation || '', industry: this.props?.userData?.industry || '', fullName: this.props?.userData?.fullName || '' };


  onACNChange = (key1, key2, value) => {
    let validChar = isValidCharacter(value);
    this.setState({ 
      [key1]: value, 
      [key2]: validChar != 2 ? null : `Special characters are not allowed. Enter Proper ${key1 == 'designation' ? 'Designation' : 'Organization Details'}`,
      acnError: validChar != 2 ? null : true, });
  };

  skipInitPage = async (callback) => {
    const { signUpData, history } = this.props;
    const { organization, phone, country_code, designation, industry } = this.state;

    try {
        if (signUpData && signUpData.user && Object.keys(signUpData.user).length > 0 && signUpData.user.access === 1) {
            if (LIVE_API && window.fpr && !String(signUpData.user.emailId).includes('taggbox.com')) {
                window.fpr("referral", { email: signUpData.user.emailId });
            }

            await this.props.selectProduct({ productId: 4, productName: 'socialwalls' }, history, async () => {
                try {
                    await updateOtherInfo({ organization, country_code, phone, designation, industry });
                } catch (ex) {
                }
            });
        } else {
            callback();
        }
    } catch (error) {
        callback();
    }
};


  onClickToFinish = () => {
    const { history, signUpData, isHome , onSubmit} = this.props;
    const { organization, phone, country_code, acnError, designation, industry, desErrorMsg, orgErrorMsg, phoneValid } = this.state;
    if(isHome){
      if(phoneValid) {
        this.setState({ spinner: true });
        updateOtherInfo({ organization, country_code, phone, designation, industry }).then(() => {
          TOAST_SUCCESS('User Info Updated Successfully');
          onSubmit();
        });
      }else{ TOAST_ERROR('Please enter valid phone number');}
    }else{
      if (!acnError) {
        this.setState({ spinner: true });
        this.skipInitPage(() => this.props.otherInfoUpate({ organization, phone, country_code, designation, industry }, history, signUpData?.activeProduct))
      }
    } 
  };

  componentDidMount() {

    this.mobValidation();
    setTimeout(() => this.getIpDetails(), 100);
  }

  componentDidUpdate() {
    this.mobValidation();
  }

  getIpDetails = async () => {
    try {
      let response = await getIPDetails();
      if (response && response.data && response.data.country) this.setState({ countrySortname: response.data.country?.toLowerCase() });
      else this.setState({ countrySortname: 'US' });
    } catch (e) {
      this.setState({ countrySortname: 'US' });
    }
  }

  mobValidation = () => {
    this.onInTelLoad();
    const self = this;
    function isNumberData(n) { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); }

    window.$(".input-phone").on("keyup", function () {
      self.setState({ acnError: null });
      if (!isNumberData(this.value)) {
        self.setState({ telValue: this.value + Math.random(), phoneValid: null, });
      }
    });
  };

  updatePhoneNumber1 = (isValid, value, selectedCountryData) => {
    var errorMsg = document.querySelector("#error-msg"),
      validMsg = document.querySelector("#valid-msg");
    var submitBtn = document.getElementById("register-submit-btn");
    var contactError = document.getElementById("contact-error");
    var input = document.querySelector("#phone");

    if (!isValidNumber(input.value)) {
      this.setState({ phone: null });
    }

    if (value) {
      if (isValid && isValidNumber(value)) {
        validMsg.classList.remove("hide");
        validMsg.innerHTML = "✓ Valid";
        submitBtn.disabled = false;
        contactError.style.display = "none";
        this.setState({ phone: value, country_code: selectedCountryData.dialCode, phoneValid: true, });
      } else {
        input.classList.add("error");
        this.setState({ telValue: !isValidNumber(value) ? value : this.state.telValue, phoneValid: false, });
        $(".input-phone").val(null);
        errorMsg.innerHTML = "Invalid number";
        errorMsg.classList.remove("hide");
        validMsg.innerHTML = "";
        validMsg.classList.add("hide");
        submitBtn.disabled = true;
        contactError.style.display = "none";
      }
    }
  };

  render() {
    const { organization, acnError, orgErrorMsg, phoneValid, telValue, spinner, countrySortname, designation, industry, displayName, nameError, desErrorMsg } = this.state;
    const { userData ,isHome} = this.props;
    const allIndustry = ['education', 'automobile', 'Non-profit', 'IT/SaaS', 'Event Services', 'healthcare', 'other']
    return (
      <>
        <Helmet>
          <script async src="https://www.googletagmanager.com/gtag/js?id=AW-919733403" ></script>
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('event', 'conversion', {'send_to': 'AW-919733403/dpLYCN33g5UBEJuJyLYD'});
            `}
          </script>
        </Helmet>

        {countrySortname ? (
          <div className="loginFormSec registerFormSec formControlMin p-0">
            <div id="AccountOtherinfoForm">
              <div className="loginWithSocials otherinfoForm">
                <div className="otherinfo-head mb-4">
                  <h4 className="mb-3">Connect & Engage with Social Walls – Begin here!</h4>
                  <p className="m-0">Begin by sharing some details for tailored solutions.</p>
                 {this.props.isHome &&   <Button variant='link' className="me-2 p-0 border-0 otherinfo-close" onClick={this.props.handleClose}> <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={'fs-4'} /> </Button>}
                </div>

                <div className="otherinfo-body">
                  <div className="form-group labelPosition mb-3">
                    <input type="hidden" name="phone" id="country_code" className="form-control placeholder-no-fix" val="1" />
                    <label htmlFor="phone">Phone Number</label>
                    <IntlTelInput fieldId="phone" key={telValue} style={{ width: `100%` }} preferredCountries={[countrySortname]} onPhoneNumberBlur={this.updatePhoneNumber1} containerClassName="intl-tel-input" inputClassName="form-control input-phone placeholder-no-fix" autocomplete="off" data-intl-tel-input-id="0" placeholder="9987654321" data-factors-input-id="form-0.field-1" />
                    <div id="contact-error"></div>
                    <div id="error-msg" className="hide" style={{ display: phoneValid ? "none" : "block", left: 0, color: "#d41220", font: "400 12px/25px 'open sans', sans-serif", }} ></div>
                    <div id="valid-msg" className="hide" style={{ display: phoneValid ? "block" : "none", left: 0, color: "green", font: "400 12px/25px 'open sans', sans-serif", }} ></div>
                  </div>

                  <div className="form-group labelPosition mb-3">
                    <label htmlFor="organization">Organization</label>
                    <input name="organization" className={`form-control placeholder-no-fix ${orgErrorMsg?.length ? ` form-error` : ``}`} type="text" value={organization} id="organization" data-factors-input-id="form-0.field-0" maxlength="20" onChange={(e) => this.onACNChange('organization', 'orgErrorMsg', e.target.value)} placeholder="Enter Your Organization..." />
                    {acnError ? (<span className="errorMessage">{orgErrorMsg}</span>) : null}
                  </div>
                  <div className="form-group labelPosition mb-3">
                    <label htmlFor="organization">Designation</label>
                    <input name="designation" className={`form-control placeholder-no-fix ${desErrorMsg?.length ? ` form-error` : ``}`} type="text" value={designation} id="designation" data-factors-input-id="form-0.field-0" maxlength="20" onChange={(e) => this.onACNChange('designation', 'desErrorMsg', e.target.value)} placeholder="Enter Your designation..." />
                    {acnError ? (<span className="errorMessage">{desErrorMsg}</span>) : null}
                  </div>
                  <div className="form-group mb-2 labelPosition">
                    <label htmlFor="organization">Mark Your Industry</label>
                    <ul className="mark-industry d-flex align-items-center flex-wrap p-0 m-0">
                      {allIndustry.map((ind) => {
                        return <li className={`cursor-pointer me-2 mb-2 rounded px-3 py-2 text-capitalize ${industry == ind ? 'active' : ''}`} onClick={e => this.setState({ industry: ind})}>{ind}</li>
                      })}
                    </ul>
                  </div>
                </div>

                <div className="pt-3">
                  <button onClick={()=>this.onClickToFinish()} id="register-submit-btn" data-style="expand-left" className={`btn btn-primary w-100`} disabled={spinner || acnError ? true : false} > {spinner ? "Please wait..." : isHome ? "Update" : "Finish"} </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    signUpData: state.signUp.signUpData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    otherInfoSkip: (history, activeProduct, stopLoading) => dispatch(otherInfoSkip(history, activeProduct, stopLoading)),
    otherInfoUpate: (data, history, redirect, spinner) => dispatch(otherInfoUpate(data, history, redirect, spinner)),
    selectProduct: (data, history, callback) => dispatch(selectProduct(data, history, callback)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OtherInfo);
